import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';
export default {
  Helmet: lazy(() => import('./components/Helmet')),
  Layout: lazy(() => import('./components/Layout')),
  Dashboard: lazy(() => import('./containers/Dashboard')),
  CustomAudiences: lazyNamed(() => import('./containers/CustomAudiences'), 'CustomAudiences'),
  CustomAudiencesConfig: lazy(() => import('./containers/CustomAudiencesConfig')),
  CustomAudiencesConfigHistory: lazyNamed(() => import('./containers/CustomAudiencesConfigHistory'), 'CustomAudiencesConfigHistory'),
  IABAudiences: lazyNamed(() => import('./containers/IABAudiences'), 'IABAudiences'),
  Domains: lazyNamed(() => import('./containers/Domains'), 'Domains'),
};
